module.exports = __webpack_public_path__ + "static/media/env-map.b149deb2.png";